import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "content",
  role: "tabpanel"
}
const _hoisted_2 = { class: "filter-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "search-input-wrapper" }
const _hoisted_5 = ["aria-label", "onKeyup", "placeholder"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "search-result-text" }
const _hoisted_10 = { class: "grey" }
const _hoisted_11 = {
  key: 0,
  class: "list-title"
}
const _hoisted_12 = {
  key: 1,
  class: "event-list event list-unstyled"
}
const _hoisted_13 = ["href", "id"]
const _hoisted_14 = { class: "img-block" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "event-content" }
const _hoisted_18 = {
  key: 0,
  class: "event-title event-title-white"
}
const _hoisted_19 = { class: "event-content-wrapper" }
const _hoisted_20 = { class: "event-info event-info-list list-unstyled" }
const _hoisted_21 = {
  key: 0,
  class: "event-info-item m-0"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: "/images/ico-location-tour.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "event-info-item m-0"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: "/images/ico-time-yellow.svg",
  alt: ""
}, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "tag"
}
const _hoisted_26 = ["onClick"]

import { TourGroupDto } from '@/models/FilterPageTypes'
import { useFilterPageStore } from '@/stores/filterPageStore'
import { computed, ref } from 'vue'
import ToursOverviewMap from './ToursOverviewMap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToursCollections',
  setup(__props) {

const isMapShowing = ref(false)

const query = ref('')
const searchResults = ref('')

const filterPageStore = useFilterPageStore()

const toursGroups = computed(() => filterPageStore.toursGroups)
const toursPageSize = computed(() => filterPageStore.toursPageSize)
const flatTours = computed(() => toursGroups.value.flatMap((i) => i.Items))

const toursDescription = computed(() => filterPageStore.toursDescr ?? '')
const searchPlaceholder = computed(() => filterPageStore.getLocalization('FilterPage.ToursCollection.SearchPlaceholder') ?? '')
const mapPlaceholder = computed(() => filterPageStore.getLocalization('FilterPage.ToursCollection.MapPlaceholder') ?? '')
const moreBtnTrans = computed(() => filterPageStore.getLocalization('FilterPage.ToursCollection.MoreToursByCategoryButton') ?? '')
const searchResultsTrans = computed(() => filterPageStore.getLocalization('FilterPage.ToursCollection.SearchResultsString') ?? '')
const timeUnits = computed(() => filterPageStore.getLocalization('FilterPage.ToursCollection.TimeUnits') ?? '')
const altClose = computed(() => filterPageStore.getLocalization("Accessability.Images.Search.Close"))
const ariaLabelSearch = computed(() => filterPageStore.getLocalization("Accessability.Search.Description"))
const searchDescr = computed(() => filterPageStore.getLocalization('Accessability.Search.Description'))
const searchClose = computed(() => filterPageStore.getLocalization('Accessability.Search.Close'))
const filledInput = computed(() => [{'filled-input': query.value}])

const getMoreBtnText = (category: string) => moreBtnTrans.value.replace('{{category}}', category)

const isCategoryHasMoreButton = (category: TourGroupDto) => category.Items.length < category.TotalItems

const getMoreToursByCategory = async (category: TourGroupDto) => {
    if (!filterPageStore.isToursFetching) {
        await filterPageStore.getMoreTours(query.value, category.GroupName, category.Items.length, toursPageSize.value - 1)
        const itemForFocus = document.getElementById(category.GroupName + toursPageSize.value)
        itemForFocus?.focus()
    }
}

const onSearchTours = async () => {
    if (!filterPageStore.isToursFetching) {
        if (!query.value)
        {
            onClearSearch();
            return;
        }
        await filterPageStore.searchTours(query.value, '', 0, toursPageSize.value)
        searchResults.value = searchResultsTrans.value.replace('{{count}}', `${filterPageStore.totalTours}`).replace('{{query}}', query.value)
    }
}

const onMapToggleClick = () => {
    isMapShowing.value = !isMapShowing.value
}

const onClearSearch = async () => {
    await filterPageStore.searchTours('', '', 0, toursPageSize.value)
    searchResults.value = '';
    query.value = '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(toursDescription))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "text",
              innerHTML: _unref(toursDescription)
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = (e) => e.preventDefault())
        }, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["search-input search-input-white tour-search-input", _unref(filledInput)]),
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
              "aria-label": _unref(ariaLabelSearch),
              onKeyup: _withKeys(onSearchTours, ["enter"]),
              placeholder: _unref(searchPlaceholder)
            }, null, 42, _hoisted_5), [
              [_vModelText, query.value]
            ]),
            (query.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onMousedown: onClearSearch,
                  class: "tour-search-close",
                  "aria-label": _unref(searchClose)
                }, [
                  _createElementVNode("img", {
                    src: "/images/ico-close.svg",
                    alt: _unref(altClose)
                  }, null, 8, _hoisted_7)
                ], 40, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: onSearchTours,
              class: "search",
              "aria-label": _unref(searchDescr)
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("button", {
            class: "search-btn map-btn",
            type: "button",
            "data-bs-toggle": "modal",
            "aria-haspopup": "dialog",
            "data-bs-backdrop": "true",
            "data-bs-target": "#tours-overview-location-picker",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onMapToggleClick()))
          }, _toDisplayString(_unref(mapPlaceholder)), 1)
        ], 32)
      ]),
      _withDirectives(_createVNode(ToursOverviewMap, {
        tours: _unref(flatTours),
        onHandleModalClose: _cache[3] || (_cache[3] = ($event: any) => (onMapToggleClick()))
      }, null, 8, ["tours"]), [
        [_vShow, isMapShowing.value]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(searchResults.value), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toursGroups), (group) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "list-wrap",
        key: group.GroupName
      }, [
        (group.GroupName)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_11, _toDisplayString(group.GroupName), 1))
          : _createCommentVNode("", true),
        (group.Items)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Items, (tour, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "event-item event-item-future tour-item",
                  key: tour.KeyId
                }, [
                  _createElementVNode("a", {
                    href: tour.DetailsUrl,
                    id: group.GroupName + index,
                    class: "event-link tour-link"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      (tour.PreviewDesktop.Url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "d-none d-lg-block img-fluid",
                            src: tour.PreviewDesktop.Url,
                            alt: ""
                          }, null, 8, _hoisted_15))
                        : _createCommentVNode("", true),
                      (tour.PreviewMobile.Url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "d-block d-lg-none img-fluid",
                            src: tour.PreviewMobile.Url,
                            alt: ""
                          }, null, 8, _hoisted_16))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (tour.Title)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_18, _toDisplayString(tour.Title), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("ul", _hoisted_20, [
                          (tour.Location)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("p", null, _toDisplayString(tour.Location), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (tour.Duration)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                _hoisted_24,
                                _createElementVNode("p", null, _toDisplayString(tour.Duration) + " " + _toDisplayString(_unref(timeUnits)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (tour.MainTag)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(tour.MainTag), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_13)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (isCategoryHasMoreButton(group))
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn btn-transparent btn-transparent-blue search-expand-btn mx-auto",
              onClick: ($event: any) => (getMoreToursByCategory(group))
            }, _toDisplayString(getMoreBtnText(group.GroupName)), 9, _hoisted_26))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 64))
}
}

})